import { useEffect } from 'react';
import { newProductKeyType } from '../../interfaces/Element.interfaces';
import { browserStorage } from '../../utils/browserStorage.util';

export const useMarkNotificationAsRead = (newProduct: { id: string } | undefined, key: newProductKeyType) => {
  useEffect(() => {
    if (newProduct && newProduct.id) {
      browserStorage.setItem({ storageType: 'localStorage', itemKey: key, value: JSON.stringify(newProduct) });
    }
  }, [newProduct]);
};
